import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";
import RefreshHub from "./features/lr-websockets";
import lazyload from "./features/lazy-load";

lazyload();

initMain(
  [],
  {
    LiveVideo: () => import("./vue/components/live-video/LiveVideo.vue"),
  },
  [RefreshHub]
);
header();
